import { appColors, BackrsChip, CareerCategory } from '@backrs_ui/common-ui';

import { CareerPathWithScore } from '@backrs_ui/grow-ui/src/models/models';

import { Box, Typography, SxProps, Theme } from '@mui/material';

import { getCareerPathFitColor, sortCareerSuggestions } from '../util/results.util';

type CareerCategoryGroupProps = Readonly<{
  index: number;
  careerPathSuggestions: CareerPathWithScore[];
  category: CareerCategory;
  setCurrentDialogCareerPath: (path: CareerPathWithScore) => void;
}>;

export const CareerCategoryGroup = ({
  index,
  careerPathSuggestions,
  category,
  setCurrentDialogCareerPath,
}: CareerCategoryGroupProps) => {
  const handleClick = (path: CareerPathWithScore) => {
    setCurrentDialogCareerPath(path);
  };

  // sort the career path suggestions by the category, but keep the original array index so we can correctly color the circles
  const suggestionsWithOriginalIndex = sortCareerSuggestions(careerPathSuggestions, category);

  return (
    <Box key={index} mt={4}>
      <Box mb={1}>
        <BackrsChip
          variant={{ type: 'LARGE_TEXT', backgroundColor: 'BLUE' }}
          label={category.name}
          sx={{
            fontSize: '15px',
            paddingX: 2,
          }}
        />
      </Box>
      {suggestionsWithOriginalIndex.map(({ path, originalIndex }) => {
        const fitColor = getCareerPathFitColor(path.scoreSection);

        return (
          <Box sx={lineItemContainerStyle} key={originalIndex} onClick={() => handleClick(path)}>
            <Box sx={smallCircleStyle} bgcolor={fitColor} />
            <Box>
              <Typography variant="body1" sx={careerPathText}>
                {path.careerPath.name}
              </Typography>
            </Box>
          </Box>
        );
      })}
    </Box>
  );
};

const careerPathText: SxProps<Theme> = {
  fontSize: '14px',
  fontWeight: 'medium',
  color: appColors.neutral.black,
  '&:hover': {
    color: `${appColors.neutral.black}60`,
  },
};

const lineItemContainerStyle: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: 1,
  mt: 0.5,
  cursor: 'pointer',
};

const smallCircleStyle: SxProps<Theme> = {
  borderRadius: '100%',
  height: '1rem',
  width: '1rem',
};
